import { render } from "./attendees-and-feedback-dashboard.vue?vue&type=template&id=64e840fc"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__